<template>
    <transition
        appear
        name="init-fade"
    >
        <div
            class="page"
            :class="{'page--merchandising-banner' : $config.homeMerchandisingBanner && !recentlyViewedEvents.length > 0}"
        >
            <div>
                <section
                    class="merchandising-banner"
                    v-if="$config.merchandisingBanner"
                >
                    <img
                        class="merchandising-banner__img--desktop"
                        :alt="$config.merchandisingBanner.desktop.alt"
                        :src="`${$store.state.imagesCdn}/${$config.merchandisingBanner.desktop.staticImagePath}`"
                    >
                    <img
                        class="merchandising-banner__img--mobile"
                        :alt="$config.merchandisingBanner.mobile.alt"
                        :src="`${$store.state.imagesCdn}/${$config.merchandisingBanner.mobile.staticImagePath}`"
                    >
                </section>
                    <transition name="fade">
                        <section
                            class="recently-viewed"
                            v-if="recentlyViewedEvents.length > 0">

                            <header>
                                <h1>Recently Viewed</h1>
                            </header>

                            <transition-group
                                class="recently-viewed__events"
                                name="fade"
                                tag="ul">
                                <li
                                    class="recently-viewed__event fade-item"
                                    v-for="(event, index) in recentlyViewedEvents"
                                    :key="event.id">
                                    <div class="recently-viewed__event-inner">
                                        <button
                                            class="icon-close"
                                            @click="removeRecentEventAt(index)"></button>
                                        <router-link
                                            class="event-link"
                                            :to="makeEventRoute(event)"
                                            @click.native="onClickRecentlyViewed"
                                        >
                                            <div class="event-details">
                                                <div
                                                    class="image"
                                                    :style="{ backgroundImage: `url(${event.imageUrlSquare || event.imageUrlRectangle})` }">
                                                </div>
                                                <div class="details">
                                                    <v-clamp class="event" :max-lines="2" autoresize>{{ event.name }}</v-clamp>
                                                    <span class="details__secondary">
                                                        <div class="date">
                                                            <span class="date--emphasized" v-if="event.isDateTbd">{{ $t('Date TBD') }}</span>
                                                            <span v-else-if="event.isTimeTbd">
                                                                <span class="date--emphasized">{{ event.localDate | date('MMM D') }}</span>, {{ event.localDate | date('YYYY')  }}, <span class="date--emphasized">{{ $t('Time TBD') }}</span>
                                                            </span>
                                                            <span v-else-if="event.localDateLabel">
                                                                <span class="date--emphasized">{{ event.localDateLabel }}</span> at {{ event.localDate | date('h:mma') }}
                                                            </span>
                                                            <span v-else>
                                                                <span class="date--emphasized">{{ event.localDate | date('MMM D') }}</span>, {{ event.localDate | date('YYYY')  }} at {{ event.localDate | date('h:mma') }}</span>
                                                            <span class="location">{{ event.venueCity }}, {{ event.venueRegionCode }}</span>
                                                        </div>
                                                        <div class="event-details-cta-wrapper">
                                                            <span class="event-details-cta icon-chevron-lg-right"></span>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </router-link>
                                    </div>
                                </li>
                            </transition-group>
                        </section>
                    </transition>

                <Banner
                    class="home-merchandising-banner"
                    v-if="$config.homeMerchandisingBanner"
                    :background-image="`${$store.state.imagesCdn}/${$config.homeMerchandisingBanner.staticImagePath}`"
                    :tagline="$config.homeMerchandisingBanner.tagline"
                    :title="$config.homeMerchandisingBanner.title"
                >
                </Banner>

                <section
                    v-if="!hasCustomTaxonomyView"
                    class="filters"
                    :class="{ 'filters--no-featured': featuredEvents.length === 0 }">
                    <LocationFilter
                        :default-location="$config.defaultLocation ? $config.defaultLocation : userLocation"
                        :location="location"
                        @error="onLocationError"
                        @select="onLocationSelect"
                    />

                    <div class="date-filter">
                        <span class="icon-calendar-blank"></span>
                        <fx-date-range
                            align="left"
                            data-e2e="home.date-filter"
                            min-date="today"
                            v-model="dateRange"
                            :custom-option-copy="'Choose Date'"
                            :default-option-copy="'Any Date'"
                            :presets="dateRangeFilterPresets"
                            @input="onDateRangeInput">
                            <span class="icon-chevron-lg-down" slot="caret"></span>
                        </fx-date-range>
                    </div>
                </section>

                <transition
                    appear
                    name="fade"
                >
                    <section v-if="featuredEvents.length">
                        <transition
                            mode="out-in"
                            name="fade"
                        >
                            <FeaturedEvents :featuredEvents="featuredEvents" :key="featuredEventsId"/>
                        </transition>
                    </section>
                </transition>

                <div class="filters-wrapper">
                    <section class="segment-filter">
                        <div class="segment-filter__shop-by">Shop by&nbsp;</div>
                        <Tabs
                            :default-item="categoryItems[0]"
                            :items="categoryItems"
                            @reset-tabs-dropdown="$router.push(makeCategoryRoute({}))"
                        />
                    </section>
                    <section
                        v-if="hasCustomTaxonomyView"
                        class="filters capital-one-filters"
                        :class="{ 'filters--no-featured': featuredEvents.length === 0 }">
                        <LocationFilter
                            :default-location="$config.defaultLocation ? $config.defaultLocation : userLocation"
                            :location="location"
                            :locationFilterCopy="'Near'"
                            @error="onLocationError"
                            @select="onLocationSelect"
                        />

                        <div class="date-filter">
                            <span class="icon-calendar-blank"></span>
                            <fx-date-range
                                align="left"
                                data-e2e="home.date-filter"
                                min-date="today"
                                v-model="dateRange"
                                :custom-option-copy="'Choose Date'"
                                :default-option-copy="'Any Date'"
                                :presets="dateRangeFilterPresets"
                                @input="onDateRangeInput">
                                <span class="icon-chevron-lg-down" slot="caret"></span>
                            </fx-date-range>
                        </div>
                    </section>
                </div>
                <section>
                    <EventList
                        :events="events"
                        :format-points="formatPoints"
                        :is-loading-events="isLoadingEvents"
                        :is-loading-more-events="isLoadingMoreEvents"
                        :is-loyalty-pricing="isLoyaltyPricing"
                        :load-more-copy="'Show More'"
                        :loading-more-copy="'Loading More Events...'"
                        :make-event-route="makeEventRoute"
                        :on-event-click="onEventClick"
                        :pagination="pagination"
                        @load-more-events="onLoadMoreEvents"
                    />
                </section>
            </div>
        </div>
    </transition>
</template>

<script>
import {
    EVENT_NAME,
    HOME
} from 'core/constants/googleAnalyticEvents'
import { parseEvent } from '../services/EventService'
import Banner from '../components/BannerComponent.vue'
import DateUtil from 'core/utilities/DateUtil'
import errorHandleable from '../mixins/ErrorHandleable'
import eventFilterable from '../mixins/EventFilterable'
import eventListable from '../mixins/EventListable'
import FeaturedEvents from '../components/FeaturedEvents.vue'
import FeaturedEventsSortStrategies from '../strategies/FeaturedEventsSortStrategies'
import LocationFilter from '../components/LocationFilter.vue'
import loyaltyFormattable from '../mixins/LoyaltyFormattable'
import quebecUserModal from '../mixins/QuebecUserModal'
import resizable from '../mixins/Resizable'
import Tabs from '../components/Tabs.vue'
import trackable from '../mixins/Trackable'
import VClamp from 'vue-clamp'

export default {
    beforeCreate () {
        this.htmlPageTitle = `Tickets for Sports, Concerts, Festivals, Theater & Shows at ${this.$config.partnerName}`

        this.featuredEventsSortStrategy = FeaturedEventsSortStrategies[this.$config.featuredEventsSortStrategyOverride] || FeaturedEventsSortStrategies.Default
    },
    components: {
        // CoreSpinner,
        Banner,
        FeaturedEvents,
        LocationFilter,
        Tabs,
        VClamp
    },
    computed: {
        isLoyaltyPricing () {
            return this.$store.state.isRedeemingLoyaltyPoints
        },
        hasCustomTaxonomyView () {
            return this.$config.hasCustomTaxonomyView
        },
        categoryItems () {
            return this.categories.map(category => ({
                isActive: category.key === this.category.key,
                label: category.label,
                to: this.makeCategoryRoute(category.key)
            }))
        }
    },
    created () {
        this.trackableEventCategory = 'UX - Homepage'
        this.trackPageView(this.$route.fullPath, this.htmlPageTitle)

        if (this.$store.state.recentEventIds.length) {
            this.$marketplace
                .getEvents({
                    event_ids: this.$store.state.recentEventIds.join(','),
                    all_in_price: this.$config.isAllInPricing ? 1 : 0
                })
                .then(response => {
                    this.recentlyViewedEvents = (response.events || [])
                        .map(event => parseEvent(event, this.$config.isIntegrated))
                        .filter(event => !event.isExpired)
                        .sort((eventA, eventB) => {
                            return this.$store.state.recentEventIds.indexOf(eventA.id) - this.$store.state.recentEventIds.indexOf(eventB.id)
                        })
                })
                .catch(errors => {
                    console.log(errors)
                })
                .finally(this.trackHasRecentEvents)
        } else {
            this.trackHasRecentEvents()
        }
    },
    data () {
        return {
            featuredEvents: [],
            featuredEventsId: 0,
            isFetchingFeaturedEvents: true,
            recentlyViewedEvents: [],
            userLocation: null
        }
    },
    head: {
        title () {
            return {
                inner: this.htmlPageTitle
            }
        }
    },
    methods: {
        fetchEvents () {
            return this.$store.state.userLocationPromise
                .then(userLocation => {
                    this.userLocation = userLocation
                    return this.$marketplace.getLocalEvents({
                        all_in_price: this.$config.isAllInPricing ? 1 : 0,
                        category: this.category ? this.category.key : null,
                        date_end: this.serializedEndDate,
                        date_start: this.serializedStartDate,
                        ignore_location: this.location ? 0 : 1,
                        location_id: this.location ? this.location.id : null,
                        latitude: this.location ? this.location.latitude : null,
                        longitude: this.location ? this.location.longitude : null,
                        page: this.page,
                        per_page: 10,
                        utc_offset: DateUtil.format(new Date(), 'Z')
                    })
                })
                .then(response => {
                    return {
                        events: response.results,
                        pagination: response.meta
                    }
                })
        },
        fetchFeaturedEvents () {
            this.isFetchingFeaturedEvents = true
            this.$store.state.userLocationPromise
                .then(() => {
                    this.$marketplace
                        .getLocalEventsCategorized({
                            all_in_price: this.$config.isAllInPricing ? 1 : 0,
                            date_end: this.serializedEndDate,
                            date_start: this.serializedStartDate,
                            location_id: this.location ? this.location.id : null,
                            latitude: this.location ? this.location.latitude : null,
                            longitude: this.location ? this.location.longitude : null,
                            ignore_location: this.location ? 0 : 1,
                            utc_offset: DateUtil.format(new Date(), 'Z')
                        })
                        .then(response => {
                            const results = response.results || {}
                            const now = new Date()

                            return Object.keys(results).reduce((acc, key) => {
                                acc[key] = results[key].events.map(event => parseEvent(event, this.$config.isIntegrated, now, window.location.origin))
                                return acc
                            }, {})
                        })
                        .then(eventsByCategory => {
                            return this.featuredEventsSortStrategy(eventsByCategory)
                        })
                        .then(featuredEvents => {
                            if (featuredEvents.length >= 5) {
                                this.featuredEvents = featuredEvents.slice(0, 5)
                            } else if (featuredEvents.length >= 2) {
                                this.featuredEvents = featuredEvents.slice(0, 2)
                            } else {
                                this.featuredEvents = []
                            }

                            this.featuredEventsId = this.featuredEventsId + 1
                        })
                        .catch(err => this.catchAndLog(err))
                        .finally(() => {
                            this.isFetchingFeaturedEvents = false
                        })
                })
        },
        fetchExclusiveFeaturedEvents () {
            this.isFetchingFeaturedEvents = true
            this.$store.state.userLocationPromise
                .then(() => {
                    this.$marketplace
                        .getExclusiveEvents({
                        })
                        .then(response => {
                            const results = response.chronological.results || {}
                            const now = new Date()

                            return results.map(event => parseEvent(event, now, window.location.origin))
                        })
                        .then(featuredEvents => {
                            if (featuredEvents.length < 2) {
                                this.featuredEvents = []
                            } else {
                                this.featuredEvents = featuredEvents
                            }
                        })
                        .catch(err => this.catchAndLog(err))
                        .finally(() => {
                            this.isFetchingFeaturedEvents = false
                        })
                })
        },
        makeCategoryRoute (key) {
            const query = { ...this.$route.query }

            delete query.category

            if (key) {
                query.category = key
            }

            return { query }
        },
        onClickCategory (nextCategory) {
            // TODO: deprecate this GA event in the future
            this.trackClickEvent(`Category ${nextCategory.key || 'all'} - Clicked`)
            this.$googleTagManager.pushEvent(EVENT_NAME,
                Object.assign({}, HOME.FILTER_BAR_TAXONOMY_SELECTED, {
                    value: nextCategory.key ? nextCategory.key : 'all'
                }))
        },
        onClickRecentlyViewed () {
            // TODO: deprecate this GA event in the future
            this.trackClickEvent('Recenty Viewed - Clicked')
            this.$googleTagManager.pushEvent(EVENT_NAME, HOME.RECENTLY_VIEWED_EVENT_TILE_SELECTED)
        },
        onDateRangeInput (dateRange) {
            // TODO: deprecate this GA event in the future
            this.trackSelectEvent('Date Filter - Selected')
            if (dateRange) {
                this.$googleTagManager.pushEvent(EVENT_NAME, HOME.DATE_FILTER_SET)
            }
            this.onDateRangeSelected(dateRange)
        },
        onEventClick () {
            // TODO: deprecate this GA event in the future
            this.trackClickEvent('Get Tickets Button - Clicked')
            this.$googleTagManager.pushEvent(EVENT_NAME, HOME.EVENT_LIST_EVENT_SELECTED)
        },
        onFeaturedEventClick (index) {
            // TODO: deprecate this GA event in the future
            this.trackClickEvent(`Tile ${index + 1} - Clicked`)
            this.$googleTagManager.pushEvent(EVENT_NAME,
                Object.assign({}, HOME.IMAGE_TILE_SELECTED, {
                    value: index + 1
                }))
        },
        onLoadMoreEvents () {
            // TODO: deprecate this GA event in the future
            this.trackClickEvent('See More Button - Clicked')
            this.$googleTagManager.pushEvent(EVENT_NAME, HOME.SEE_MORE_BUTTON_SELECTED)
            this.loadMoreEvents()
        },
        onLocationSelect (location) {
            // TODO: deprecate this GA event in the future
            this.trackSelectEvent('Location Filter - Selected')
            this.$googleTagManager.pushEvent(EVENT_NAME, HOME.LOCATION_FILTER_CHANGED)
            this.onLocationSelected(location)
        },
        removeRecentEventAt (index) {
            this.recentlyViewedEvents = this.recentlyViewedEvents.slice(0, index).concat(this.recentlyViewedEvents.slice(index + 1))
            this.$store.commit('removeRecentEventIdAt', index)
        },
        trackHasRecentEvents () {
            if (this.$googleTagManager) {
                this.$googleTagManager.pushEvent('dimension6', {
                    hasRecentEvents: this.recentlyViewedEvents.length > 0
                })
            }
        }
    },
    mixins: [
        errorHandleable,
        eventFilterable,
        eventListable,
        loyaltyFormattable,
        quebecUserModal,
        resizable,
        trackable
    ]
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.date-filter {
    margin-left: auto;
    position: static;
    z-index: 20;
    font-weight: var(--fw-light);
    @media (--mq-large-min) {
        position: relative;
    }

    & .fx-date-range {
        display: inline-block;
    }

    & .icon-calendar-blank {
        color: #808689;
        font-size: var(--fs-large);
        margin-right: 4px;
        position: relative;
        top: 2px;
    }

    & >>> .fx-selection {
        color: #808689;
        font-size: var(--fs-large);
        font-weight: var(--fw-light);
        text-decoration: underline;
    }

    & >>> .icon-cancel {
        color: #808689;
        font-size: var(--fs-large);
        font-weight: var(--fw-light);
        position: relative;
        text-decoration: none;
        right: 3px;
        top: 4px;
    }

    & >>> .icon-chevron-lg-down {
        color: #808689;
        font-size: 14px;
        position: relative;
        right: 3px;
        top: 3px;
    }

    & >>> .fx-select-dropdown {
        z-index: 20;

        & li {
            padding: 10px 16px;

            &.selected,
            &:active,
            &:focus,
            &:hover {
                background: linear-gradient(-90deg, rgba(60, 172, 209, 0.00) 0%, rgba(28, 116, 165, 0.13) 100%);
                border-left: 4px solid #1c74a5;
                color: #808689;
                padding-left: 12px;

                & .icon-checkmark {
                    display: none;
                }

                & .fx-option-label {
                    text-decoration: none;
                }
            }
        }
    }

    & >>> .fx-select-custom {
        padding: 0 14px 0 0;
    }

    & >>> .fx-select-input {
        border-bottom: 0 !important;
    }

    @media (--mq-medium-min) {
        & >>> .fx-selection {
            font-size: var(--fs-large);
        }
    }

    @media (--mq-large-min) {
        margin-left: 24px;
    }
}

.filters-wrapper {
    display: flex;
    flex-direction: column;
    @media (--mq-large-min) {
        flex-direction: row;
        margin-bottom: 24px;
    }
}

.segment-filter {
    color: #444649;
    display: flex;
    margin-bottom: 24px;
    margin-top: 8px;
    @media (--mq-large-min) {
        display: block;
        margin-bottom: 0;
        margin-top: 0;

    }

    & .segment-filter__shop-by {
        font-size: 20px;
        @media (--mq-large-min) {
            font-size: 24px;
            margin-bottom: 24px;
        }
    }
}

.filters {
    align-items: center;
    display: flex;
    flex-direction: row;

    & .date-filter {
        & >>> .icon-cancel {
            top: 2px !important;
        }
    }
    &.filters--no-featured {
        margin-bottom: 20px;
    }
    &.capital-one-filters {
        align-items: center;
        margin-bottom: 16px;
        margin-top: 0;

        @media (--mq-large-min) {
            display: flex;
            margin-bottom: 0px;
            margin-left: 24px;
            margin-top: 55px;
        }
        & .date-filter {
            margin-left: 24px;
        }
    }
}

.merchandising-banner {
    margin-bottom: 30px;
    overflow: hidden;

    & img {
        display: block;
        max-width: 100%;

        &.merchandising-banner__img--desktop {
            display: none;
        }
    }

    @media (--mq-large-min) {
        & img {
            &.merchandising-banner__img--desktop {
                display: block;
            }

            &.merchandising-banner__img--mobile {
                display: none;
            }
        }
    }
}

.page {
    margin: 0 auto;
    max-width: 960px;
    padding: 24px var(--site-padding);

    &.page--merchandising-banner {
        padding: 0 var(--site-padding) 24px var(--site-padding);
        transition-delay: 0.5s;
        transition: all 0.75s ease-out;
    }
}

.recently-viewed {
    display: block;
    margin-bottom: 30px;

    & header {
        color: #6C7275;
        display: flex;

        & h1 {
            color: #444649;
            font-size: 24px;
            font-weight: 300;
            margin-top: 0;
        }
    }

    & .recently-viewed__events {
        display: block;
        list-style: none;
        margin: 0;
        padding: 0;

        @media (--mq-large-min) {
            margin: 0 -10px;
        }

        & .recently-viewed__event {
            position: relative;
            margin: 0 0 8px;
            width: 100%;

            @media (--mq-large-min) {
                margin: 0 10px;
                width: calc(33.3% - 20px);
            }

            & .recently-viewed__event-inner {
                transition: transform 0.2s ease;

                &:active,
                &:focus,
                &:hover {
                    box-shadow: 0 1px 8px 0 rgba(0,0,0,0.2);
                    transform: scale(1.01);
                    transition: transform 0.2s ease;
                }
            }

            & .event-link {
                background: white;
                border-radius: var(--d-border-radius);
                border: 1px solid #bcc1c2;
                box-shadow: 0 2px 4px 0 #a2aaad;
                box-sizing: border-box;
                cursor: pointer;
                display: block;
                height: 96px;
                position: relative;
                text-decoration: none;

                &:active,
                &:focus,
                &:hover {
                    text-decoration: none;
                }
            }

            & .event-details {
                display: flex;
                flex-direction: row;

                & .details {
                    flex: 1 1 100%;
                    line-height: 18px;
                    overflow: hidden;
                    padding: 8px;
                    text-overflow: ellipsis;

                    & .event {
                        color: #444649;
                        font-size: var(--fs-normal);
                        font-weight: var(--fw-normal);
                        height: 36px;
                        margin-bottom: 8px;
                        max-width: 80%;
                        overflow: hidden;
                    }

                    & .date {
                        color: #444649;
                        display: inline-block;
                        font-size: var(--fs-small);
                        font-weight: 100;
                        max-width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;

                        & .date--emphasized {
                            font-weight: 300;
                        }
                    }

                    & .location {
                        color: #444649;
                        display: block;
                        font-size: var(--fs-small);
                        font-weight: 100;
                        max-width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                & .image {
                    background-color: var(--c-primary);
                    background-position: 50% 50%;
                    background-repeat: no-repeat;
                    background-size: cover;
                    border-radius: 4px 0 0 4px;
                    flex: 0 0 95px;
                    height: 95px;
                    overflow: hidden;
                }

                & .details__secondary {
                    align-content: center;
                    align-items: center;
                    display: flex;
                    justify-content: space-between;
                }

                & .event-details-cta-wrapper {
                    border: 1px solid transparent;
                    height: 32px;
                    padding: 12px;
                    width: 32px;

                    &:active,
                    &:focus,
                    &:hover {
                        border-radius: 16px;
                        border: 1px solid var(--c-primary);
                        transition: transform 0.2s ease;
                    }

                    & .event-details-cta {
                        color: var(--c-primary);
                        font-size: 16px;
                        position: relative;
                        right: 4px;
                        top: -4px;

                    }
                }
            }

            & .icon-close {
                background: none;
                border: none;
                color: #808689;
                cursor: pointer;
                display: block;
                height: 20px;
                line-height: 0.8em;
                padding: 0;
                position: absolute;
                right: 6px;
                top: 6px;
                width: 20px;
                z-index: 5;
            }
        }
        @media (--mq-large-min) {
            display: flex;
        }
    }
}

.transition-banner {
    border-radius: 5px;
    margin-bottom: 30px;
    overflow: hidden;

    & img {
        display: block;
        max-width: 100%;

        &.transition-banner__img--desktop {
            display: none;
        }
    }

    @media (--mq-large-min) {
        & img {
            &.transition-banner__img--desktop {
                display: block;
            }

            &.transition-banner__img--mobile {
                display: none;
            }
        }
    }
}

>>>.tag--exclusive{
    padding: 0 8px;
}

>>>.home-merchandising-banner.banner {
    margin: 0 0 0 -16px;
    @media (--mq-large-min) {
        margin: 24px 0 24px 0;
    }
}

/* Transitions */
.fade-enter-active {
    transition: opacity 1s ease;
}

.fade-leave-active {
    transition: opacity 1s ease;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.init-fade-enter-active {
    transition: opacity 1.5s ease;
}

.init-fade-leave-active {
    transition: none;
}

.init-fade-enter,
.init-fade-leave-to,
.init-fade-leave {
    opacity: 0;
}

</style>
